import { ActivityAttachmentForm } from '@stores/AttachmentStore';
import { types, Instance } from 'mobx-state-tree';
export const ActivityBoard = types.model({
  filterModalVisible: false,
  forms: types.map(types.late(() => ActivityAttachmentForm))
}).actions(self => ({
  setFilterModalVisible(isVisible: boolean) {
    self.filterModalVisible = isVisible;
  },
  addForm(form: {
    id: string;
    activityID?: string;
  }) {
    return self.forms.put(form);
  },
  reset() {
    self.forms.clear();
  }
}));
export type IActivityBoard = Instance<typeof ActivityBoard>;